import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import TopSliceImg from '../../images/slice_hero_top.svg'
import RightSliceImg from '../../images/slice_hero_right.svg'
import LeftSliceImg from '../../images/slice_hero_left.svg'
import Hero1 from '../../images/hero1.jpg'
import Hero2 from '../../images/hero2.jpg'
import Hero3 from '../../images/hero3.png'

const Hero = () => {
  const heroes = [Hero3, Hero2, Hero1]
  const [currentBgHeroIndex, setCurrentBgHeroIndex] = useState(0)
  const [showSlices, setShowSlices] = useState(false)
  // Chi ha chiesto meno animazioni al sistema operativo parte con lo
  // scorrimento gia' fermo (WCAG 2.2.2 — ZHJ37).
  const [isPaused, setIsPaused] = useState(
    () => typeof window !== 'undefined'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )

  const changeBg = () => {
    setCurrentBgHeroIndex((prev) => {
      if (prev + 1 >= heroes.length) return 0
      return prev + 1
    })
  }

  useEffect(() => {
    if (isPaused) return
    setShowSlices(true)
    const intervalId = setTimeout(() => {
      changeBg()
      setShowSlices(false)
    }, 4000)
    return () => clearTimeout(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBgHeroIndex, isPaused])

  return (
    <Section>
      {/* nessun role="main": l'Hero e' un carosello decorativo, il landmark
          principale e' il <main> di PageLayout (Y8L80, JQJUM) */}
      <PauseButton type="button" onClick={() => setIsPaused((p) => !p)}>
        {isPaused
          ? 'Riprendi lo scorrimento delle immagini'
          : 'Metti in pausa lo scorrimento delle immagini'}
      </PauseButton>
      <Wrapper>
        <HeroContainer>
          <HeroItem
            style={{
              backgroundImage: `url(${heroes[currentBgHeroIndex]})`,
              transition: 'background-image 0.7s ease'
            }}>
            {showSlices && <SliceLeft />}
            {showSlices && <SliceTop />}
            {showSlices && <SliceRight />}
            <HeroText>
              <TextScrim>
                {
                  currentBgHeroIndex === 2 &&
                  <HeroCaption>
                    <p>
                      Ricevi da subito il tuo
                      <br />
                      <strong>trattamento di fine servizio</strong>
                    </p>
                  </HeroCaption>
                }
                {
                  currentBgHeroIndex === 1 &&
                  <HeroCaption>
                    <p>
                      La{' '}
                      <strong>
                        cessione del <br />
                        quinto{' '}
                      </strong>
                      comodamente <br />
                      da casa tua
                    </p>
                  </HeroCaption>
                }
                {
                  currentBgHeroIndex === 0 &&
                  <HeroCaption>
                    <p>
                      DAI VITA AI TUOI <strong>PROGETTI</strong><br/>
                      REALIZZALI ADESSO
                    </p>
                  </HeroCaption>
                }
              </TextScrim>
            </HeroText>
          </HeroItem>
        </HeroContainer>
      </Wrapper>
    </Section>
  )
}

export default Hero

const appearFromTop = keyframes`
  from {
    transform: translateX(-62%) translateY(-100%);
  }
  to {
    transform: translateX(-62%) translateY(0);
  }
`

const appearFromLeft = keyframes`
  from {
    transform: translateX(-100%) translateY(-48%);
  }
  to {
    transform: translateX(0) translateY(-48%);
  }
`

const appearFromRight = keyframes`
  from {
    transform: translateX(100%) translateY(-48%);
  }
  to {
    transform: translateX(0) translateY(-48%);
  }
`
/* 44px di altezza minima: sopra il minimo di 24x24 di WCAG 2.5.8. */
const PauseButton = styled.button`
  position: absolute;
  right: 1rem;
  /* 8rem, non 1rem: la barra "CON QuintoPuoi REALIZZARE I TUOI PROGETTI"
     si sovrappone agli ultimi 80px dell'Hero e copriva il pulsante,
     rendendolo inutilizzabile (misurato con elementFromPoint). */
  bottom: 8rem;
  z-index: 50;
  min-height: 44px;
  padding: 0.5rem 1.2rem;
  font-family: inherit;
  font-size: 1.1rem;
  font-weight: 700;
  /* #222 su #fff = 15.9:1 */
  color: #222222;
  background: #ffffff;
  border: 2px solid #222222;
  border-radius: 2rem;
  cursor: pointer;

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
  }
`

const Section = styled.section`
  position: relative;
  display: block;
  width: 100%;
  z-index: 1;
  min-height: 33rem;
  transform-origin: center;
`

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
`

const HeroContainer = styled.div`
  width: 100%;
`

const HeroItem = styled.div`
  height: 100%;
  background-position: 80% center;
  background-size: cover;
  transition: all 0.3s ease-out;
  min-height: 70rem;
  position: relative;
  @media (min-width: 769px) {
    background-position: center center;
  }
`

const HeroTextContainer = styled.div`
  position: absolute;
  top: 44%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  max-width: 111rem;
  text-align: center;
  text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
`

const SliceTop = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  max-width: 56rem;
  padding-bottom: 58rem;
  width: 50%;
  transition: all 0.24s ease-out;
  opacity: 0.8;
  z-index: 1;
  background-image: url(${TopSliceImg});
  background-position: center top;
  top: 0;
  left: 50%;
  animation: ${appearFromTop} 0.5s ease;
  transform: translateX(-62%);
`

const SliceLeft = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  max-width: 22rem;
  padding-bottom: 58rem;
  width: 15%;
  transition: all 0.24s ease-out;
  opacity: 0.8;
  top: 50%;
  z-index: 1;
  left: 0;
  background-image: url(${LeftSliceImg});
  background-position: left center;
  animation: ${appearFromLeft} 0.7s ease;
  transform: translateY(-48%);
`
const SliceRight = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  max-width: 22rem;
  padding-bottom: 58rem;
  width: 15%;
  transition: all 0.24s ease-out;
  opacity: 0.8;
  top: 50%;
  z-index: 1;

  right: 0;
  background-image: url(${RightSliceImg});
  background-position: right center;
  animation: ${appearFromRight} 0.7s ease;
  transform: translateY(-48%);
`

const HeroText = styled.div`
  position: absolute;
  top: 44%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  max-width: 111rem;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
`

/* Il testo dell'hero sta sopra una fotografia policroma: nessun colore di
   testo puo' garantire il rapporto di contrasto, perche' il fondo cambia da
   pixel a pixel. Campionati i pixel delle 3 immagini nella regione del blocco
   di testo, hero3 contiene pixel BIANCO PURO (luminanza 1.000): li' il giallo
   #fcbb00 valeva 1.71:1 e il bianco 1.00:1.

   #222 al 95% sopra quel caso peggiore da' 5.8:1 sul giallo e 10.0:1 sul
   bianco, contro un minimo di 3:1 per il testo grande (WCAG 1.4.3).
   Misure e alternative valutate in documentazione della remediation a11y, fuori dal repo, Fase A. */
const TextScrim = styled.div`
  display: inline-block;
  background-color: rgba(34, 34, 34, 0.95);
  border-radius: 1.2rem;
  padding: 2.5rem 3rem;
  max-width: 100%;

  @media (max-width: 767px) {
    padding: 1.5rem 1.8rem;
    border-radius: 0.8rem;
  }
`

const HeroCaption = styled.div`
  margin-bottom: 2rem;
  & p {
    @media (max-width: 1140px) {
      font-size: 4rem;
    }
    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
    font-size: 6rem;
    text-transform: uppercase;
    color: #fff;
    letter-spacing: 2px;
    line-height: 1.1;
    font-weight: 700;
    & :last-child {
      margin-bottom: 0;
    }
    & strong {
      color: #fcbb00;
    }
  }
`

/*



  <TopSlice>
            <img
              src={TopSliceImg}
              alt="" aria-hidden="true"
              style={{ position: "absolute", top: "0", left: "35%" }}
            />
          </TopSlice>
          <LeftSlice>
            <img
              src={LeftSliceImg}
              alt="" aria-hidden="true"
              style={{ position: "absolute", top: "0", left: "0" }}
            />
          </LeftSlice>
          <RightSlice>
            <img
              src={RightSliceImg}
              alt="" aria-hidden="true"
              style={{ position: "absolute", bottom: "0", right: "0" }}
            />
          </RightSlice>
          <HeroTextContainer>
            {currentBgHero === Hero1 ? (
              <h2
                style={{
                  textTransform: "uppercase",
                  color: "#fff",
                  fontSize: "2.8em",
                  textShadow: "-1px 2px 5px #9C402F",
                }}
              >
                Ricevi subito il tuo
                <br />
                <span
                  style={{
                    color: "#fcbb00",
                    fontSize: "inherit",
                    textShadow: "inherit",
                  }}
                >
                  trattamento di fine servizio
                </span>
              </h2>
            ) : (
              <h2
                style={{
                  textTransform: "uppercase",
                  color: "#fff",
                  fontSize: "2.8em",
                  textShadow: "-1px 2px 5px #9C402F",
                }}
              >
                La{" "}
                <span
                  style={{
                    color: "#fcbb00",
                    fontSize: "inherit",
                    textShadow: "inherit",
                  }}
                >
                  cessione del Quinto{" "}
                </span>
                comodamente da casa tua
              </h2>
            )}
          </HeroTextContainer>


















*/

